import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const apiClient = axios.create({
  baseURL: `${BASE_URL}/api`,
});

// Attach token for admin and auth routes
apiClient.interceptors.request.use((config) => {
  // Add token for /admin/* and /auth/* routes (except /auth/login)
  if (config.url && (config.url.startsWith("/admin") || 
      (config.url.startsWith("/auth") && !config.url.includes("/auth/login")))) {
    const token = window.localStorage.getItem("sla_admin_token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

export const setAdminToken = (token) => {
  if (token) {
    window.localStorage.setItem("sla_admin_token", token);
  } else {
    window.localStorage.removeItem("sla_admin_token");
  }
};
